import React from 'react';
import {
  withStyles,
  Paper,
  Grid
} from '@material-ui/core';
import styles from './AlertWidget.styles';
import { useAlertDetails } from 'api/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';
import { getKeyId } from '../FieldsWidget/FieldsWidget.utils';
import { ELEVATION_LEVEL, MD, SM, XS } from './AlertField.constants';
import { IAlertWidgetProps } from './AlertWidget.properties';
import AlertField, { HeadingComponent } from './AlertWidget.components';

const AlertWidget: React.FC<IAlertWidgetProps> = ({
  classes,
  showHeading = true,
  schema,
  ...props
}) => {
  const KeyId = getKeyId(props);
  const { data: dataSets } = useAlertDetails(schema?.DashboardId, KeyId);
  const filteredDataSetAlerts = dataSets?.DashboardAlertData?.Widgets.filter((dataSet) => schema?.DashboardWidgetId === dataSet?.DashWidgetId?.Value)?.[0]?.Alerts?.Value;

  if (!KeyId || dataSets?.DashboardAlertData?.Widgets?.length === 0) {

    return null;
  }

  return (
    <Grid item xs={XS} sm={SM} md={MD} className={classes.widgetContainer}>
      <Paper elevation={ELEVATION_LEVEL} className={classes.root}>
        {
          schema?.WidgetTitle && <HeadingComponent showHeading={showHeading} heading={schema?.WidgetTitle} />
        }
        <div className={classes.alertsContainer}>
          {filteredDataSetAlerts?.map((alert) => <AlertField alert={alert} />)}
        </div>
      </Paper>
    </Grid>
  );
};

export default withStyles(styles)(AlertWidget);
